import { AnyAction } from 'redux';
import { Category } from './category.types';

import {
  fetchCategoriesStart,
  fetchCategoriesSuccess,
  fetchCategoriesFailed,
} from './category.action';

export type CategoriesState = {
  readonly categories: Category[];
  readonly isLoading: boolean;
  readonly error: Error | null;
};

export const CATEGORIES_INITIAL_STATE: CategoriesState = {
  categories: [],
  isLoading: false,
  error: null,
};

export const categoriesReducer = (
  state = CATEGORIES_INITIAL_STATE,
  action: AnyAction
): CategoriesState => {
  if (fetchCategoriesStart.match(action)) {
    return { ...state, isLoading: true };
  }
  if (fetchCategoriesSuccess.match(action)) {
    return { ...state, categories: action.payload, isLoading: false };
  }
  if (fetchCategoriesFailed.match(action)) {
    return { ...state, error: action.payload, isLoading: false };
  }
  // const { type, payload } = action;

  // switch (action.type) {
  //   case CATEGORIES_ACTION_TYPES.FETCH_CATEGORIES_START:
  //     return { ...state, isLoading: true };
  //   case CATEGORIES_ACTION_TYPES.FETCH_CATEGORIES_SUCCESS:
  //     return { ...state, categories: action.payload, isLoading: false };
  //   case CATEGORIES_ACTION_TYPES.FETCH_CATEGORIES_FAILED:
  //     return { ...state, error: action.payload, isLoading: false };

  //   default:
  //     return state;

  return state;
};
/*
///////////////////////////// type predicate function //////////////////////

type Alien = {
  fly: () => {};
};

type Human = {
  speak: () => {};
};

function isHuman(entity: Human | Alien): entity is Human {
  return (entity as Human).speak !== undefined;
}

const Josh;

if (isHuman(Josh)) {
  Josh.speak();
}
*/
//////////////////////////// Intersections & Return Types /////////////////////////////
/*
//Intersection type
type Human = {
  name: string;
};

type Alien = {
  fly: () => void;
};

type Hybrid = Human & Alien; // intersection

const Josh: Hybrid = {
  name: 'Josh',
  fly: () => {},
};
*/
/*

// Return type

type Human = {
  name: string;
};

type MyFunc = () => Human;

type MyReturn = ReturnType<MyFunc>; // using 'ReturnType<>' keyword



//////////////////////// .match property ////////////////////////
const myFunc = () => console.log('hit');
myFunc(); // output: 'hit'

myFunc.match = () => console.log('hat');
myFunc(); // output: 'hit'

myFunc.match(); // output: 'hat'
// this '.match' property is extending the capabality of a function, it is allowing us to add additional features onto a function.
*/
